import React from 'react';
import OmnitureUtils from '../../../../../../../../common/utils/Omniture/OmnitureUtils';
import { faOnTopFilterRemove } from '../analytics-services';
import './styles.scss';

const FilterTabs = ({ filterValue, handleFilterChange }) => {
  const handleFilterRemove = () => {
    const newValue = filterValue?.currentFilterValue?.filter(
      value => value !== filterValue?.optionData?.uniqueId
    );
    faOnTopFilterRemove(filterValue?.urlParam, filterValue?.optionData?.uniqueId);
    OmnitureUtils.trackClickEvent({
      prop54: `filter_remove_collection_${filterValue?.urlParam}_${filterValue?.optionData?.uniqueId}`,
    });

    handleFilterChange({ urlParam: filterValue?.urlParam, values: newValue });
  };

  return (
    <span className="filterTabs">
      {filterValue?.optionData?.prefix}
      {filterValue?.optionData?.filterText}
      {filterValue?.optionData?.suffix}{' '}
      <span className="icon mmt-cross" onClick={handleFilterRemove} />
    </span>
  );
};
export default FilterTabs;
